import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "../Store/Slice/UserSlice";
import authReducer from "../Store/Slice/authSlice";
import productReducer from "../Store/Slice/productSlice";
import filterReducer from "../Store/Slice/filterSlice";
import wastageReducer from "../Store/Slice/wastageSlice";
import onboardingReducer from "../Store/Slice/onboardingSlice";
import cartReducer from "../Store/Slice/cartSlice"; 
import popupTriggerReducer from "../Store/Slice/popupTriggerSlice"; 
import liveRateReducer from "../Store/Slice/liveRateSlice";
import walletReducer from "../Store/Slice/walletSlice";
import rewardPointReducer from "../Store/Slice/rewardPointSlice";

import userRolePermissionReducer from "../Store/Slice/userRolePermissionSlice";
import { thunk } from "redux-thunk"; // Import thunk correctly
import authSlice from "../Store/Slice/authSlice";

// Combine reducers
const rootReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  userRolePermission: userRolePermissionReducer,
  authSlice: authSlice,
  productSlice: productReducer,
  onboardingSlice: onboardingReducer,
  filter: filterReducer,
  wastage: wastageReducer,
  cart: cartReducer,
  popupTrigger: popupTriggerReducer,
  liveRate: liveRateReducer ,
  wallet: walletReducer,
  rewardPoint: rewardPointReducer,
  // Add other reducers here if needed
});

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["liveRate"], // Add slices you don't want to persist
  debug: true,
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Middleware setup function
const setupMiddleware = () => {
  const middleware = [thunk];
  return middleware;
};

// Create Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: () => setupMiddleware(),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools in development
});

// Create persistor object
export const persistor = persistStore(store);
